import Nullstack from 'nullstack';
export default function IconBrandGraphql({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-brand-graphql",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M5.308 7.265l5.385 -3.029"
  }), "   ", Nullstack.element("path", {
    d: "M13.308 4.235l5.384 3.03"
  }), "   ", Nullstack.element("path", {
    d: "M20 9.5v5"
  }), "   ", Nullstack.element("path", {
    d: "M18.693 16.736l-5.385 3.029"
  }), "   ", Nullstack.element("path", {
    d: "M10.692 19.765l-5.384 -3.03"
  }), "   ", Nullstack.element("path", {
    d: "M4 14.5v-5"
  }), "   ", Nullstack.element("path", {
    d: "M12.772 4.786l6.121 10.202"
  }), "   ", Nullstack.element("path", {
    d: "M18.5 16h-13"
  }), "   ", Nullstack.element("path", {
    d: "M5.107 14.988l6.122 -10.201"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "3.5",
    r: "1.5"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "20.5",
    r: "1.5"
  }), "   ", Nullstack.element("circle", {
    cx: "4",
    cy: "8",
    r: "1.5"
  }), "   ", Nullstack.element("circle", {
    cx: "4",
    cy: "16",
    r: "1.5"
  }), "   ", Nullstack.element("circle", {
    cx: "20",
    cy: "16",
    r: "1.5"
  }), "   ", Nullstack.element("circle", {
    cx: "20",
    cy: "8",
    r: "1.5"
  }), " ");
}